import React from "react";
import { Card, CardContent, Typography, Box, Chip, Alert } from "@mui/material";
import { CustomCellDate } from "@/shared/components/DateCell";
import type { Migration } from "@/admin/entities/migrations";

const getStatusColor = (status?: string | null) => {
  switch (status) {
    case "succeeded":
      return "success";
    case "failed":
      return "error";
    case "processing":
      return "warning";
    default:
      return "default";
  }
};

const getStatusLabel = (status?: string | null) => {
  switch (status) {
    case "succeeded":
      return "Выполнена";
    case "failed":
      return "Ошибка";
    case "processing":
      return "Выполняется";
    default:
      return "Не запущена";
  }
};

interface MigrationBasicInfoProps {
  migration: Migration;
}

export const MigrationBasicInfo: React.FC<MigrationBasicInfoProps> = ({
  migration,
}) => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h5" component="h2">
            {migration.title}
          </Typography>
          <Chip
            label={getStatusLabel(migration.status)}
            color={getStatusColor(migration.status)}
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Дата создания
            </Typography>
            <CustomCellDate date={migration.createdAt} />
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Последний запуск
            </Typography>
            {migration.lastRunAt ? (
              <CustomCellDate date={migration.lastRunAt} />
            ) : (
              <Typography variant="body1">Не запускалась</Typography>
            )}
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Количество попыток
            </Typography>
            <Typography variant="body1">
              {migration.attemptsMade || 0}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              ID
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: "monospace" }}>
              {migration.id}
            </Typography>
          </Box>
        </Box>

        {migration.error && (
          <Box sx={{ mt: 2 }}>
            <Alert severity="error">
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Ошибка выполнения:
              </Typography>
              <Typography
                variant="body2"
                component="pre"
                sx={{
                  whiteSpace: "pre-wrap",
                  fontFamily: "monospace",
                  fontSize: "0.75rem",
                }}
              >
                {migration.error}
              </Typography>
            </Alert>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
